module.exports = __webpack_public_path__ + "static/media/user-circle.32d3e1ef.svg";